<template>
    <div class="adjustmentPlanReport">
        <div class="tableBox" v-if="targetCareer">
            <p class="adjustTitle">专、职业目标调整</p>
            <table>
                <tbody>
                    <tr>
                <th rowSpan="2">目标职业</th>
                <td>{{version==1?'目标职业领域':'目标职业类'}}：{{targetCareer.targetCareerField}}</td>
            </tr>
            <tr>
                <td>目标职业：
                    <template >
                        <span v-for="(item,index) in targetCareer.targetCareer" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                    </span>
                    </template>
                </td>
            </tr>

            <tr>
                <th :rowspan="2">目标专业</th>
                <td v-if="version==2||version==0">目标专业类：{{professional}}</td>
            </tr>
            <tr>
                <td>目标专业：
                    <template>
                        <span v-for="(item,index) in targetCareer.targetSubject" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                        </span>
                    </template>
                </td>
            </tr>




                </tbody>
            </table>
            <div class="summary">
                <SummaryTitle class="" title='咨询记录'/>
                <el-input class="area" disabled="disabled"  type="textarea" :value="targetCareer.targetRemark"  rows="5" maxLength='500'></el-input>
            </div>
        </div>
        <div class="tableBox" v-if="university">
            <p class="adjustTitle">院校、分数目标调整</p>
            <table>
                <tbody>
                    <tr>
                        <th>目标院校</th>
                        <td>
                            <template v-if="university.universityIdName">
                            <span v-for="(item,index) in university.universityIdName" :key="index">
                                <template v-if="index>0">、</template>
                                {{item.name}}
                            </span>
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <th>目标分数</th>
                        <td>
                            {{university.score}} / {{university.rank}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="summary">
                <SummaryTitle title='咨询记录'/>
                <el-input class="area"  disabled="disabled"  type="textarea" :value="university.remarkLog"  rows="5" maxLength='500'></el-input>
            </div>
        </div>
        <div class="tableBox" v-if="further">
            <p class="adjustTitle">路径、条件目标调整</p>
            <table>
                <tbody>
                    <tr>
                        <th rowspan="3">目标路径</th>
                        <td>升学路径：{{further.furtherWay}}</td>
                    </tr>
                    <tr>
                        <td>路径条件：{{further.furtherWayNeed}}</td>
                    </tr>
                    <tr>
                        <td>其他条件：{{further.furtherWayNeedOther}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="summary">
                <SummaryTitle title='咨询记录'/>
                <el-input class="area"  disabled="disabled"  type="textarea"  :value="further.furtherWayRemark"  rows="5" maxLength='500'></el-input>
            </div>
        </div>
        <div class="tableBox" v-if="choose">
            <p class="adjustTitle">选科调整</p>
            <table>
                <tbody>
                    <tr>
                        <th>目标选科</th>
                        <td>
                            <template v-if=" choose.chooseSubjectName">
                                <span v-for="(item,index) in choose.chooseSubjectName" :key="index">
                                    <template v-if="index>0">、</template>
                                    {{item}}
                                </span>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="summary">
                <SummaryTitle title='咨询记录'/>
                <el-input class="area"  disabled="disabled"  type="textarea" :value="choose.chooseSubjectRemark"  rows="5" maxLength='500'></el-input>
            </div>
        </div>
    </div>
</template>
<script>
import SummaryTitle from './SummaryTitle.vue'
export default {
    name: "planReport",
    props: ['targetCareer', 'university', 'further', 'choose','version','professional'],
    components: {
        SummaryTitle
    },
    data() {
        return {
        }
    },
    mounted(){
        console.log(this.version)
    }
}
</script>
<style scoped lang="less">
.adjustmentPlanReport {
    .tableBox {
        background-color: #fff;
        padding-bottom: 55px;
        .adjustTitle {
            font-size: 22px;
            font-weight: 500;
            color: #3D90F6;
            line-height: 30px;
            margin-bottom: 20px;
        }
        textarea {
            background-color: red;
        }
        table {
            width: 100%;
            tbody {
                font-size: 16px;
                tr {
                    line-height: 40px;
                    th {
                        font-weight: bold;
                        text-align: center;
                        font-size: 16px;
                        width: 148px;
                        border: 1px solid #3D90F6;
                        background: rgba(61, 144, 246, 0.1);
                    }

                    td {
                        font-size: 14px;
                        padding-left: 40px;
                        border: 1px solid #3D90F6;
                    }
                }
            }
        }
        .summary {
            padding-top: 30px;
            textarea {
                background-color: red;
            }
        }

    }
}
</style>
<style lang="less">
.adjustmentPlanReport {
    .el-textarea.is-disabled .el-textarea__inner  {
        background: rgba(61, 144, 246, 0.2);;
        color: #333;
    }
}
</style>